import '.ex{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ey{padding-left:1.5rem;}.ssr-plugin'
import '.ez{margin:1rem 0;}.ssr-plugin'
import '.f0{color:var(--gray-700);}.ssr-plugin'
import '.f1{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ex ey ez f0 f1"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
